module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatments-invisalign",
    attrs: {
      "id": "invisalign"
    }
  }, [_c('div', {
    staticClass: "custom-treatments-invisalign__container"
  }, [_c('div', {
    staticClass: "custom-treatments-invisalign__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatments-invisalign__row"
  }, [_c('div', {
    staticClass: "custom-treatments-invisalign__left"
  }, [_c('Icon', {
    staticClass: "custom-treatments-invisalign__logo",
    attrs: {
      "name": "invisalign"
    }
  }), _c('div', {
    staticClass: "custom-treatments-invisalign__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), _c('div', {
    staticClass: "custom-treatments-invisalign__read-more",
    on: {
      "click": function($event) {
        return _vm.toInvisalign()
      }
    }
  }, [_vm._v("Read More")])], 1), _c('div', {
    staticClass: "custom-treatments-invisalign__right",
    style: ({
      backgroundImage: 'url(' + _vm.props.img + ')'
    })
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb985a5a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-treatments-invisalign/custom-treatments-invisalign.pug
// module id = 737
// module chunks = 1